import { render, staticRenderFns } from "./substitutions.vue?vue&type=template&id=a31a8124&scoped=true&"
import script from "./substitutions.vue?vue&type=script&lang=js&"
export * from "./substitutions.vue?vue&type=script&lang=js&"
import style0 from "./substitutions.vue?vue&type=style&index=0&id=a31a8124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31a8124",
  null
  
)

export default component.exports